<template>
    <div class="filter-section">
        <h5>{{ title }}</h5>
        <md-field>
            <label>{{ placeholder }}</label>
            <md-input v-model="inputValue" @input="emitChange"></md-input>
        </md-field>
    </div>
</template>

<script>
export default {
    name: 'TextFilter',
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default() {
                return `Enter ${this.title.toLowerCase()}...`;
            }
        },
        value: {
            type: String,
            default: ''
        },
        currentFilterValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            inputValue: this.value
        };
    },
    watch: {
        value(newValue) {
            this.inputValue = newValue;
        }
    },
    methods: {
        emitChange() {
            this.$emit('change', {
                id: this.id,
                value: this.inputValue,
                component: 'TextFilter'
            });
        },
        reset() {
            this.inputValue = this.currentFilterValue;
            this.emitChange();
        }
    }
};
</script>

<style scoped>
.filter-section {
    margin-bottom: 0px;
}

.filter-section h5 {
    margin-top: 0;
    margin-bottom: 0px;
    font-weight: 500;
}
</style>
